import axios from 'axios';
import { API_URL } from '../config/api';

// Sandbox de teste de agentes de IA: simula a conversa com a MESMA pipeline de produção
// (prompt + KB reais do agente, modelo, splitter, gates e handoff) sem enviar WhatsApp
// nem tocar contatos/memória persistente.

export interface AiSandboxTranscriptEntry {
  role: 'customer' | 'ai' | 'system';
  parts: string[];
  at: string;
  latencyMs?: number | null;
  transferred: boolean;
}

export interface AiSandboxSession {
  sessionId: string;
  sectorId: number;
  agentId: number;
  agentName: string;
  context: 'receptive' | 'campaign';
  contactName: string;
  model: string;
  transferred: boolean;
  memory?: string | null;
  createdAt: string;
  transcript: AiSandboxTranscriptEntry[];
}

export interface AiSandboxMessageResult {
  parts: string[];
  transferred: boolean;
  markerDetected: boolean;
  domainDecision: string;
  model: string;
  latencyMs: number;
  memory?: string | null;
  toolCalls: string[];
  systemPromptChars: number;
  note?: string | null;
}

const headers = (token: string) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export async function startSandboxSession(
  sectorId: number,
  agentId: number,
  context: 'receptive' | 'campaign',
  contactName: string | undefined,
  token: string
): Promise<AiSandboxSession> {
  const res = await axios.post(
    `${API_URL}/AiSandbox/session`,
    { sectorId, agentId, context, contactName },
    { headers: headers(token) }
  );
  return res.data.data;
}

export async function sendSandboxMessage(
  sessionId: string,
  text: string,
  token: string
): Promise<AiSandboxMessageResult> {
  const res = await axios.post(
    `${API_URL}/AiSandbox/session/${sessionId}/message`,
    { text },
    { headers: headers(token) }
  );
  return res.data.data;
}

export async function deleteSandboxSession(sessionId: string, token: string): Promise<void> {
  await axios.delete(`${API_URL}/AiSandbox/session/${sessionId}`, { headers: headers(token) });
}
